import type { SVGProps } from 'react';

interface NextTriangleIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const NextTriangleIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & NextTriangleIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 32 58"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="M.75 1.693 30.384 28.58.75 55.465z"
      stroke="#4FA9FF"
      strokeWidth={1.5}
    />
  </svg>
);
